export const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "pending", label: "Pending" },
  { value: "under-review", label: "Under review" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

const LABELS = {
  "jogging-running": "Jogging / Running",
  football: "Football",
  cricket: "Cricket",
  athletics: "Athletics",
  "martial-arts": "Martial arts",
  "gym-fitness": "Gym / Fitness",
  other: "Other",
  daily: "Daily",
  "3-5-week": "3–5 times a week",
  "1-2-week": "1–2 times a week",
  rarely: "Rarely",
  "under-2km": "Under 2 km",
  "2-5km": "2–5 km",
  "5-10km": "5–10 km",
  "10km-or-more": "10 km or more",
  "half-marathon": "Half marathon (21Km)",
  "full-marathon": "Full marathon (42Km)",
  "5k": "5K",
  "10k": "10K",
  "lack-safe-spaces": "Lack of safe spaces",
  "family-social": "Family / social",
  cost: "Cost",
  "no-transport": "No transport",
  "no-coach": "No coach",
  "no-one-to-run-with": "No one to run with",
  "time-work": "Time / work",
  yes: "Yes",
  no: "No",
  "not-sure": "Not sure",
  "early-morning": "Early morning",
  evening: "Evening",
  weekends: "Weekends",
  instagram: "Instagram",
  facebook: "Facebook",
  "friend-family": "Friend / family",
  "community-liaison": "Community liaison",
  pending: "Pending",
  "under-review": "Under review",
  approved: "Approved",
  rejected: "Rejected",
};

export const formatLabel = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (Array.isArray(value)) {
    return value.length ? value.map((v) => formatLabel(v)).join(", ") : "-";
  }
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return LABELS[value] || String(value).replace(/-/g, " ");
};

export const statusColor = (status) => {
  switch (status) {
    case "pending":
      return "rgb(240 154 30)";
    case "under-review":
      return "#1e87f0";
    case "approved":
      return "#32d296";
    case "rejected":
      return "#f0506e";
    default:
      return "#999";
  }
};

export const PAGE_SIZE = 50;
